import { j as e } from "../../../../../../../jsx-runtime.BREq8dyb.js";
import { faKey as o, faLockKeyhole as t } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as r } from "@fortawesome/react-fontawesome";
import { Typography as a, Alert as s } from "@mui/joy";
import { memo as n, Fragment as i } from "react";
const l = n(() => /* @__PURE__ */ e.jsxs(i, { children: [
  /* @__PURE__ */ e.jsx(a, { level: "title-md", startDecorator: /* @__PURE__ */ e.jsx(r, { icon: o }), children: "Credentials" }),
  /* @__PURE__ */ e.jsx(s, { color: "secondary", size: "sm", startDecorator: /* @__PURE__ */ e.jsx(r, { icon: t }), children: "Credentials are encrypted and are used by the enclave just once." })
] }));
l.displayName = "CredentialsLabel";
export {
  l as default
};
//# sourceMappingURL=CredentialsLabel.js.map
